<template>
    <main id="home" class="flex h-full items-end overflow-hidden relative">
        <picture class="h-full w-full">
            <source srcset="images/home-large.png" media="(min-width: 1224px)">
            <source srcset="images/home-medium.png" media="(min-width: 576px)">
            <img class="object-cover h-full w-full" src="images/home-small.png" alt="Silhouletten Gruppen Bild " />
        </picture>
    </main>
</template>

<script>
export default {
    name: 'home'
}
</script>